import { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Container, Dimmer, Grid, Loader } from 'semantic-ui-react';
import { get } from '../../utils/lodash';
import { SuccessContainer } from '../../components';
import { APP_NAME } from '../../utils/constant';
import { checkMailVerified } from '../../store/actions';
import { EMAIL_VERIFICATION_STATUS } from '../../utils/constant';

import './auth.scss';

class MailVerification extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const { t } = this.props;
    document.title = `${t('auth.pages.email_verification')} | ${APP_NAME}`;
    const {
      checkMailVerified,
      match: {
        params: { token = null },
      },
    } = this.props;
    checkMailVerified(token);
  }

  render() {
    const { t, emailVerifyLoading, emailVerify } = this.props;
    let emailVerificationStatus;
    if (emailVerify) {
      emailVerificationStatus = EMAIL_VERIFICATION_STATUS(t).find(
        (entry) => entry.status === emailVerify.status
      );
    }

    if (!emailVerificationStatus) {
      return <></>;
    }

    const emailStatus = get(emailVerificationStatus, 'status', null);

    return (
      <Grid.Row>
        <Container className="email-verification-container">
          <Grid>
            <Grid.Row>
              {emailVerifyLoading && !emailVerificationStatus ? null : (
                <SuccessContainer
                  noBgEffects
                  header={get(emailVerificationStatus, 'header', null)} //message
                  msg={get(emailVerificationStatus, 'message', null)}
                  description={get(
                    emailVerificationStatus,
                    'description',
                    null
                  )}
                  linkExpired={emailStatus === 'REQUEST_INVALID'}
                  success={emailStatus !== 'REQUEST_INVALID'}
                  button={
                    emailStatus !== 'REQUEST_INVALID'
                      ? 'Return to Takso'
                      : 'Return to Sign in'
                  }
                  buttonRoute="/dashboard"
                  overRideBtn={emailStatus !== 'REQUEST_INVALID'}
                />
              )}
            </Grid.Row>
          </Grid>
          <Dimmer active={emailVerifyLoading} inverted>
            <Loader content={t('common.loading')} />
          </Dimmer>
        </Container>
      </Grid.Row>
    );
  }
}

const mapStateToProps = (state) => {
  const { emailVerify, emailVerifyLoading } = state.authentication;
  return {
    emailVerify,
    emailVerifyLoading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      checkMailVerified,
    },
    dispatch
  );
};

MailVerification = connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(MailVerification));

export default MailVerification;
